var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.143 10.102H11.9067V13.4754H16.8941C16.5246 14.525 15.8292 15.4245 14.9274 16.0457C14.0907 16.624 13.0802 16.956 11.9936 16.956C9.69002 16.956 7.73418 15.4567 7.04963 13.3898C6.87578 12.8757 6.78885 12.3295 6.78885 11.7619C6.78885 11.1622 6.88664 10.5946 7.07136 10.0591C7.77764 8.02432 9.71176 6.56784 11.9827 6.56784C13.2214 6.56784 14.3623 7.00693 15.2642 7.73517L17.6221 5.55044C16.09 4.09396 14.0255 3.20508 11.7545 3.20508C8.44045 3.20508 5.57188 5.08994 4.14845 7.84226C3.53997 9.0203 3.20312 10.3483 3.20312 11.7619C3.20312 13.1434 3.5291 14.45 4.11585 15.6066C5.51755 18.4018 8.41872 20.3188 11.7654 20.3188C13.9929 20.3188 16.0139 19.4727 17.5352 18.0805C19.2411 16.5169 20.3168 14.2679 20.3168 11.7619C20.3059 11.1943 20.2516 10.6374 20.143 10.102Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogin);
export default __webpack_public_path__ + "static/media/google-login.2ddc79f50d540b6aba27a194c7fe14df.svg";
export { ForwardRef as ReactComponent };